import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getCurrentUser } from '../utils/authManager';

export default function AdminProtected({ children }) {
  const navigate = useNavigate();
  const user = getCurrentUser();
  
  useEffect(() => {
    if (!user || !['admin@aenedu.site', 'vip@aenedu.site'].includes(user.email)) {
      alert('🚫 您没有管理员权限');
      navigate('/');
    }
  }, [user, navigate]);
  
  if (!user || !['admin@aenedu.site', 'vip@aenedu.site'].includes(user.email)) {
    return null;
  }
  
  return children;
}